import cn from 'classnames';
import { Link } from '@/ui-components/atoms/Link/Link';
import styles from '../../navheader.module.scss';
import { NavItem } from '../../NavHeader.type';

export interface NavLinkItemProps {
    index: number;
    isDarkTheme: boolean;
    item: NavItem;
    setHelpCenterHovered: (isHovered: boolean) => void;
    setNavDropdownHoveredIndex: (newIndex: number | null) => void;
}

export function NavLinkItem({
    index,
    isDarkTheme,
    item,
    setHelpCenterHovered,
    setNavDropdownHoveredIndex,
}: NavLinkItemProps) {
    const itemId = `header-nav-item-${index}`;
    const isActive = typeof window !== 'undefined' && window.location.pathname === item.link;

    if (item.link) {
        return (
            <li
                key={index}
                className={cn(styles.topNavItem, {
                    [styles.darktheme]: isDarkTheme,
                })}
            >
                <Link
                    href={item.link}
                    className={cn(styles.topNavLink, {
                        [styles.darktheme]: isDarkTheme,
                        [styles.active]: isActive,
                    })}
                    id={itemId}
                    onKeyDown={(e) => {
                        if (e.key === 'Escape') {
                            setNavDropdownHoveredIndex(null);
                            setHelpCenterHovered(false);
                        }
                    }}
                >
                    <span>{item.title}</span>
                </Link>
            </li>
        );
    } else {
        return (
            <li
                key={index}
                className={cn(styles.topNavItem, {
                    [styles.darktheme]: isDarkTheme,
                })}
            >
                <button
                    className={cn(styles.topNavButton, {
                        [styles.darktheme]: isDarkTheme,
                    })}
                    aria-label={item.title}
                    onKeyDown={(e) => {
                        if (e.key === 'Escape') {
                            setNavDropdownHoveredIndex(null);
                            setHelpCenterHovered(false);
                        }
                    }}
                >
                    <span className={styles.mobDropdownTitle}>{item.title}</span>
                </button>
            </li>
        );
    }
}
